module.exports = __webpack_public_path__ + "static/media/container-001.f266828c.jpg";